import { render, staticRenderFns } from "./mermaid.vue?vue&type=template&id=60d17cb5&scoped=true"
import script from "./mermaid.vue?vue&type=script&lang=js"
export * from "./mermaid.vue?vue&type=script&lang=js"
import style0 from "./mermaid.vue?vue&type=style&index=0&id=60d17cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d17cb5",
  null
  
)

export default component.exports